import { buildOurStory } from "../sections";

document.addEventListener("DOMContentLoaded", (event) => {
  if (
    document.body.dataset.template == "page" &&
    document.body.dataset.suffix == "story"
  ) {
    buildOurStory();
  }
});
